import { createSelector } from 'reselect';

const selectRaw = (state) => state.workflowLaunch.list;

const selectLoading = createSelector(
  [selectRaw],
  (raw) => raw.loading,
);
const selectExportLoading = createSelector(
  [selectRaw],
  (raw) => raw.exportLoading,
);
const selectRows = createSelector(
  [selectRaw],
  (raw) => raw.rows,
);
const selectCount = createSelector(
  [selectRaw],
  (raw) => raw.count,
);
const selectHasRows = createSelector(
  [selectCount],
  (count) => count > 0,
);
const selectOrderBy = createSelector([selectRaw], (raw) => {
  const sorter = raw.sorter;
  if (!sorter || !sorter.field) return null;
  const direction =
    sorter.order === 'descend' ? 'DESC' : 'ASC';
  return `${sorter.field}_${direction}`;
});
const selectFilter = createSelector(
  [selectRaw],
  (raw) => raw.filter,
);
const selectRawFilter = createSelector(
  [selectRaw],
  (raw) => raw.rawFilter,
);
const selectLimit = createSelector(
  [selectRaw],
  (raw) => raw.pagination.pageSize,
);
const selectOffset = createSelector([selectRaw], (raw) => {
  const pagination = raw.pagination;
  if (!pagination || !pagination.pageSize) return 0;
  const current = pagination.current || 1;
  return (current - 1) * pagination.pageSize;
});
const selectPagination = createSelector(
  [selectRaw, selectCount],
  (raw, count) => ({
    ...raw.pagination,
    total: count,
    showSizeChanger: true,
  }),
);
const selectSelectedKeys = createSelector(
  [selectRaw],
  (raw) => raw.selectedKeys,
);
const selectSelectedRows = createSelector(
  [selectRaw, selectRows],
  (raw, rows) =>
    rows.filter((row) => raw.selectedKeys.includes(row.id)),
);

const workflowLaunchListSelectors = {
  selectLoading,
  selectRows,
  selectCount,
  selectOrderBy,
  selectLimit,
  selectFilter,
  selectOffset,
  selectPagination,
  selectSelectedKeys,
  selectSelectedRows,
  selectHasRows,
  selectExportLoading,
  selectRawFilter,
};

export default workflowLaunchListSelectors;
